import React from "react";
import "./Modal.scss";

interface InputGroupProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: "text" | "textarea" | "date" | "select" | "email" ;
  options?: string[];
  error?: string;
  readOnly?: boolean;
  minHeight?: number;
}

export const TextInput: React.FC<InputGroupProps> = ({
  label,
  value,
  onChange,
  placeholder,
  error,
  readOnly = false,
}) => (
  <div className="input-group">
    <label>{label}</label>
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      readOnly={readOnly}
    />
    {error && <p className="error">{error}</p>}
  </div>
);

export const TextArea: React.FC<InputGroupProps> = ({
  label,
  value,
  onChange,
  placeholder,
  error,
  minHeight,
}) => (
  <div className="input-group">
    <label>{label}</label>
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={{ minHeight: minHeight ? `${minHeight}px` : undefined }}
    />
    {error && <p className="error">{error}</p>}
  </div>
);

export const DateInput: React.FC<InputGroupProps> = ({
  label,
  value,
  onChange,
}) => (
  <div className="input-group">
    <label>{label}</label>
    <input
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export const SelectInput: React.FC<InputGroupProps> = ({
  label,
  value,
  onChange,
  options = [],
}) => (
  <div className="input-group">
    <label>{label}</label>
    <select value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
);
